export const moduleName = `report_exceptions`

export const SAVE_EXCEPTION_NOTE = `${moduleName}_save_exception_note`
export const SAVE_EXCEPTION_NOTE_REQUEST = `${moduleName}_save_exception_note_request`
export const SAVE_EXCEPTION_NOTE_SUCCESS = `${moduleName}_save_exception_note_success`
export const SAVE_EXCEPTION_NOTE_ERROR = `${moduleName}_save_exception_note_error`

export const RESET = `${moduleName}_reset`

export const FETCH = `${moduleName}_fetch`
export const FETCH_ERROR = `${moduleName}_fetch_error`
export const FETCH_FULFILLED = `${moduleName}_fetch_fulfilled`


export const ACKNOWLEDGE_EXCEPTIONS = `${moduleName}_acknowledge_exceptions`
export const ACKNOWLEDGE_EXCEPTIONS_ERROR = `${moduleName}_acknowledge_exceptions_error`
export const ACKNOWLEDGE_EXCEPTIONS_FULFILLED = `${moduleName}_acknowledge_exceptions_fulfilled`

// Fuel Exception Notes - GET
export const GET_EXCEPTION_NOTES = `${moduleName}_get_exception_notes`
export const GET_EXCEPTION_NOTES_REQUEST = `${moduleName}_get_exception_notes_request`
export const GET_EXCEPTION_NOTES_SUCCESS = `${moduleName}_get_exception_notes_success`
export const GET_EXCEPTION_NOTES_ERROR = `${moduleName}_get_exception_notes_error`

// Fuel Exception Notes - UPDATE
export const UPDATE_EXCEPTION_NOTE = `${moduleName}_update_exception_note`
export const UPDATE_EXCEPTION_NOTE_REQUEST = `${moduleName}_update_exception_note_request`
export const UPDATE_EXCEPTION_NOTE_SUCCESS = `${moduleName}_update_exception_note_success`
export const UPDATE_EXCEPTION_NOTE_ERROR = `${moduleName}_update_exception_note_error`

// Fuel Exception Notes - DELETE
export const DELETE_EXCEPTION_NOTE = `${moduleName}_delete_exception_note`
export const DELETE_EXCEPTION_NOTE_REQUEST = `${moduleName}_delete_exception_note_request`
export const DELETE_EXCEPTION_NOTE_SUCCESS = `${moduleName}_delete_exception_note_success`
export const DELETE_EXCEPTION_NOTE_ERROR = `${moduleName}_delete_exception_note_error`

export const GET_EXCEPTION_ISSUE = `${moduleName}_get_exception_issue`
export const GET_EXCEPTION_ISSUE_REQUEST = `${moduleName}_get_exception_issue_request`
export const GET_EXCEPTION_ISSUE_SUCCESS = `${moduleName}_get_exception_issue_success`
export const GET_EXCEPTION_ISSUE_ERROR = `${moduleName}_get_exception_issue_error`

export const GET_EXCEPTION_HISTORY = `${moduleName}_get_exception_history`
export const GET_EXCEPTION_HISTORY_REQUEST = `${moduleName}_get_exception_history_request`
export const GET_EXCEPTION_HISTORY_SUCCESS = `${moduleName}_get_exception_history_success`
export const GET_EXCEPTION_HISTORY_ERROR = `${moduleName}_get_exception_history_error`

export const SELECT_ROW = `${moduleName}_select_row`

export const EXCEPTION_STATUS = {
  PENDING_REVIEW: 'pending review',
  REVIEWED: 'reviewed',
}
